@import '../../../globals/main.scss';
@import './pn-product-card-common.scss';

pn-product-card-info {
  align-self: center;
}

.cardinfocontent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  font-size: 0.875em;
  gap: 1.6rem;
  @media screen and (min-width: $productcard-media-oversmallmobile) {
    flex-direction: row;
  }
  > div p {
    margin: 0.25em 0.25em 0 0;
  }
}

.cardinfocontent-item {
  margin-top: 0.5em;
}
[slot='formatPre'] {
  font-family: 'PostNordSans', 'Verdana';
  > strong {
    font-weight: bold;
  }
  margin: 0.5em 3em 0 0;
}

.cardinfoprice {
  display: flex;
  font-size: 1em;
  flex-direction: row;
  justify-content: center;
  flex-grow: 1;
}
